<template>
  <jade-box
    class="flex-1"
    :title="$t('pending.title')"
    hasPadding
  >
    <template>
      <div class="flex flex-col gap-2">
        <jade-text variant="heading-small">R$ {{ data.value }}</jade-text>
        <div>
          <jade-text>{{ computedText.label }}</jade-text>
          <jade-text>{{ computedText.percentage }}</jade-text>
        </div>
      </div>
    </template>
  </jade-box>
</template>

<script>
import { JadeBox, JadeText } from '@jade'
import TransactionStatusManager from './transaction-status.manager'

export default {
  name: 'TransactionStatusPending',

  components: {
    JadeBox,
    JadeText
  },

  props: {
    data: Object
  },

  computed: {
    computedText () {
      const label = this.$tc('pending.sales', this.data.quantity)
      return TransactionStatusManager.getFormatedLabelAndPercentage(
        this.data,
        label
      )
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "pending": {
        "title": "Pendente",
        "description": "Cobranças autorizadas e ainda não capturadas. Inclui também boletos que ainda não foram pagos e estão dentro do vencimento, assim como boletos pagos a menor.",
        "sales": "cobrança | cobrança | cobranças"
      }
    },
    "en-US": {
      "pending": {
        "title": "Pending",
        "description": "Authorized charges that haven’t been captured yet. Also includes boletos that haven’t yet been paid and are still valid, as also underpaid boletos.",
        "sales": "charge | charge | charges"
      }
    }
  }
  </i18n>
